import { shadowBoxAccent } from "customStyles/shadowBox";
import { secondaryDatagridStyle } from "customStyles/datagrid";
export const loadingStyle = {
  container: {
    position: "fixed",
    top: "30vh",
    left: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    textAlign: "center",
  },
  text: {
    marginTop: "20px",
    fontSize: "24px",
  },
};

export const mobileList = {
  padding: "1rem",
  border: "0.031rem solid #d6d1d0a3",
  "& .RaSimpleList-tertiary": {
    opacity: 1,
  },
  "& .MuiListItem-root": {
    borderBottom: "0.031rem solid #d6d1d0a3",
  },
};

export const secondaryDatagrid = secondaryDatagridStyle({ main: "#1B61D4", dark: "#022F8B" });
export const secondaryLeftAlignedDatagrid = secondaryDatagridStyle(
  { main: "#1B61D4", dark: "#022F8B" },
  { textAlign: "left" },
);
export const modalSecondaryDatagrid = {
  "& .RaDatagrid-headerCell": {
    position: "relative",
    backgroundColor: "#0c0155",
    // The theme header paints a gradient (background-image) over any background-color - clear it.
    backgroundImage: "none",
    color: "#fff",
    fontWeight: 700,
    fontSize: 12,
    paddingRight: "5px",
    paddingLeft: "10px",
  },
};
export const expandStyle = {
  "& .RaDatagrid-expandIcon": {
    color: "#1B61D4",
    fontSize: "30px",
  },
};

export const blockStyle = {
  "& .RaList-actions": {
    display: "block",
  },
  "& .RaDatagrid-expandIcon": {
    color: "#1B61D4",
    fontSize: "30px",
  },
};

export const firstExpandIconDatagrid = {
  "& .RaDatagrid-headerCell": {
    paddingLeft: "16px",
  },
  "& .RaDatagrid-headerCell:first-of-type ": {
    paddingLeft: "10px",
  },
  "& .RaDatagrid-headerCell:first-of-type .RaDatagrid-expandIcon ": {
    color: "#fff",
  },
};

export const shadowBox = {
  width: "94%",
  // 94% + the 2rem side margins overflows below ~1067px of content (900px screens up to ~15"); cap it.
  maxWidth: "calc(100% - 4rem)",
  margin: "0.5rem 2rem 2rem 2rem",
  padding: "1rem",
  ...shadowBoxAccent({ main: "#1B61D4", dark: "#022F8B" }),
};

export const shadowBoxMobile = {
  width: "94%",
  margin: "0.2rem",
  padding: "0.5rem",
  ...shadowBoxAccent({ main: "#1B61D4", dark: "#022F8B" }, { barWidth: 5 }),
};

export const mobileLabel = {
  color: "#04459b",
};

export const InputCardStyle = {
  margin: "0.75rem 0",
  display: "flex",
  justifyContent: "space-around",
  padding: "2rem",
};

export const CardContentStyle = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "1rem",
  padding: "1.5rem !important",
  marginBottom: "1rem",
  marginX: "1rem",
};

export const iteratorNone = {
  "& .RaSimpleFormIterator-line": {
    borderLeft: "0px solid transparent",
    backgroundColor: "#F5F5F5",
    padding: "0rem",
    marginBottom: "-1rem",
  },
};
export const iteratorWithoutGap = {
  "& .RaSimpleFormIterator-line": { mb: 1 },
};

export const gridContainer = {
  marginLeft: ".2rem",
  borderLeft: "5px solid #1B61D4",
  backgroundColor: "#F5F5F5",
  borderRadius: "5px",
  padding: "2rem",
  marginBottom: "2.5rem",
};

export const textAria = {
  minHeight: "20rem",
  maxWidth: "44rem",
  overflowY: "auto",
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "16px",
    borderColor: "#1B61D4",
    overflowY: "auto",
  },
  "& .MuiOutlinedInput-input": {
    margin: "1rem",
    minHeight: "20rem",
    overflowY: "auto",
  },
};
export const customDatagridStyle = {
  border: "0.5px solid #d6d1d0a3",
  borderRadius: "5px",
  overflow: "hidden",
  backgroundColor: "#fff",

  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: "#BEBEBE",
    color: "#000",
    fontWeight: 700,
    fontSize: 15,
    paddingRight: "5px",
    paddingLeft: "10px",
    paddingTop: "9px",
    paddingBottom: "9px",
    textAlign: "center",
    borderBottom: "1px solid #d6d1d0a3",
  },

  "& .MuiTableBody-root .MuiTableCell-root": {
    paddingRight: "5px",
    paddingLeft: "10px",
    paddingTop: "9px",
    paddingBottom: "9px",
    textAlign: "center",
    borderBottom: "1px solid #e0e0e0",
    fontSize: 14,
  },

  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
    borderBottom: "none",
  },
};
export const dialogInputLabelStyle = {
  width: "100%",
  position: "relative",
  left: "0px",
  top: "5px",
  fontSize: "0.8rem",
  color: "#1B61D4",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};
export const indexStyle = {
  width: "30px",
  height: "30px",
  backgroundColor: "#1B61D4",
  color: "#fff",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const fieldStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const dialogStyle = {
  "& .MuiDialog-paper": {
    textAlign: "center",
    maxHeight: "80%",
    minWidth: "80%",
    minHeight: "40%",
  },
  "& .MuiDialogActions-root": {
    marginTop: "1rem",
    padding: "1rem",
    justifyContent: "space-between",
  },
};
export const richTextInput = {
  "& .ProseMirror": {
    minHeight: "200px",
    maxHeight: "500px",
    overflowY: "auto",
  },
};

// Datagrids with many columns (7+): 16px -> 8px side padding on header and row cells, so the table
// fits a 14" screen without horizontal scroll. Combine with firstExpandIconDatagrid by spreading both.
export const compactDatagridCells = {
  "& .RaDatagrid-headerCell, & .RaDatagrid-rowCell": {
    paddingLeft: 1,
    paddingRight: 1,
  },
};

// Row action buttons in a Datagrid cell: wrap to the next line (and let labels wrap) on narrower
// screens instead of widening the column.
export const wrappingActionButtons = {
  display: "flex",
  flexWrap: "wrap",
  columnGap: 2,
  rowGap: 1,
  alignItems: "center",
  "& .MuiButton-root": { whiteSpace: "normal", textAlign: "left" },
};

// Like wrappingActionButtons, but below xl (1536px, i.e. 14" laptops) the buttons stack in a single
// vertical column; on wider screens they sit in a wrapping row.
export const stackingActionButtons = {
  ...wrappingActionButtons,
  flexDirection: { xs: "column", xl: "row" },
  alignItems: { xs: "flex-start", xl: "center" },
};

// Look of the shared UI (modals, section titles, details tables, ...): true - the new one, false - the old one.
// SU keeps the old look for now.
export const modernUi = true;

// Datagrids nested in Show (details) pages: the secondary look with the new UI, the plain Datagrid without it.
export const detailsDatagrid = secondaryDatagrid;
